var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    attrs: {
      "id": "__members-area"
    }
  }, [_c('loading-overlay', {
    attrs: {
      "wait-for": !_vm.debug
    }
  }), _vm._v(" "), _vm.debug ? _c('div', {
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": "https://emoji.slack-edge.com/TBNJLMD9S/pug/20e20b28b9f78871.gif",
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', [_vm._v("auth handoff debug")]), _vm._v(" "), _c('p', {
    staticClass: "mt-6 font-bold"
  }, [_vm._v("Input url:")]), _vm._v(" "), _c('p', {
    staticClass: "clickable",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v(_vm._s(_vm.$route.fullPath))]), _vm._v(" "), _c('p', {
    staticClass: "mt-6 font-bold"
  }, [_vm._v("Parsed params:")]), _vm._v(" "), _c('ul', _vm._l(Object.entries(_vm.$route.query), function (param) {
    return _c('li', {
      key: param[0],
      staticClass: "clickable",
      on: {
        "click": _vm.copy
      }
    }, [_vm._v("\n\t\t\t\t- " + _vm._s(param[0]) + ": " + _vm._s(param[1]) + "\n\t\t\t")]);
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "mt-6 font-bold"
  }, [_vm._v("From app:")]), _vm._v(" "), _c('p', {
    staticClass: "clickable",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v(_vm._s(_vm.debugFromApp ? 'yes' : 'no'))]), _vm._v(" "), _c('p', {
    staticClass: "mt-6 font-bold"
  }, [_vm._v("Redirect to:")]), _vm._v(" "), _c('p', {
    staticClass: "clickable",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v(_vm._s(_vm.debugRedirectTo || 'n/a'))]), _vm._v(" "), _c('p', {
    staticClass: "mt-6 font-bold"
  }, [_vm._v("member token:")]), _vm._v(" "), _c('p', {
    staticClass: "clickable",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v(_vm._s(_vm.debugMemberToken || 'n/a'))]), _vm._v(" "), _c('p', {
    staticClass: "mt-6 font-bold"
  }, [_vm._v("user token:")]), _vm._v(" "), _c('p', {
    staticClass: "clickable",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v(_vm._s(_vm.debugUserToken || 'n/a'))]), _vm._v(" "), _c('p', {
    staticClass: "mt-6 font-bold"
  }, [_vm._v("error")]), _vm._v(" "), _c('p', {
    staticClass: "clickable",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.debugError ? _vm.debugError.response && _vm.debugError.response.data ? `${_vm.debugError.response.status}: ${JSON.stringify(_vm.debugError.response.data)}` : `${_vm.debugError.name} ${_vm.debugError.message}` : 'none') + "\n\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "mt-8 text-lg button--filled button--mint",
    on: {
      "click": _vm.debugContinue
    }
  }, [_vm._v("\n\t\t\tContinue →\n\t\t")])]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };